import { ProductType } from '~/techstyle-shared/react-products';

// Get available stock for a master product.
// Loops over the product's options and returns the quantity.
export function getAvailableProductQuantity(product) {
  switch (product.productTypeId) {
    case ProductType.BUNDLE:
      // GraphQL Product format
      if (product.bundleComponentProducts) {
        return Math.max(
          ...product.bundleComponentProducts.map((bundleItem) => {
            if (bundleItem.skus) {
              return Math.max(
                ...bundleItem.skus.map((sku) => sku.availableQuantity)
              );
            }
            return 0;
          })
        );
      }

      // checking for scarcity callout condition in bundle items
      if (product.bundleItems?.length > 0 && product.cartLineId) {
        const refinedAvailableQuantity = product.bundleItems
          .map((element) => {
            return element.availableQuantity;
          })
          .sort((a, b) => a - b);
        return refinedAvailableQuantity[0];
      }

      // Tier1 /products/v2 format
      if (
        !product.productOptionProfileIdObjectList ||
        product.productOptionProfileIdObjectList.length === 0
      ) {
        // No sizes available in filtered size
        return product.availableQuantityAnyProfile;
      }
      return Math.max(
        ...product.productOptionProfileIdObjectList.map(
          (productObj) => productObj.availableQuantity
        )
      );

    default:
      // GraphQL Product format
      if (product.skus) {
        return Math.max(...product.skus.map((sku) => sku.availableQuantity));
      }

      if (product.cartLineId) {
        return product.availableQuantity;
      }

      // Tier1 /products/v2 format
      if (
        !product.productIdObjectList ||
        product.productIdObjectList.length === 0
      ) {
        return product.availableQuantityMaster;
      }
      return Math.max(
        ...product.productIdObjectList.map(
          (productObj) => productObj.availableQuantity
        )
      );
  }
}
